import { catchError, map} from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ResponseModel} from "../../../core/base/response.model";
import {RestServiceAbstract} from "../../../core/base/rest.service.abstract";


@Injectable({
  providedIn: 'root',
})
export class PreordersManagementService extends RestServiceAbstract {
  private readonly destroyRef = inject(DestroyRef);

  getCategory() {
    return this.get(`/${this.RESOURCE}/admin/preorders/category/in-delivery`).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }

  upload(data: any) {
    return this.post(`/${this.RESOURCE}/admin/preorders/delivery/upload`, data).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }
}
